// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"dc34ae40","265":"2c1d40a7","673":"aa209c3e","787":"18830742","898":"d54d72a5"}[chunkId] + ".chunk.js";
};